import { render } from "./CookieOptOutBanner.vue?vue&type=template&id=6a3ef3a4"
import script from "./CookieOptOutBanner.vue?vue&type=script&lang=js"
export * from "./CookieOptOutBanner.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src900218826/src/production-ready-serverless-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__